import { Component } from "react";

class SchemeInfo extends Component{
    constructor(props){
        super(props);
        this.state={
            code: '',
            name: '',
            activities:['']
        }
    }

    handleNameChange = (event) =>{
        this.setState({name: event.target.value});
    } 

    handleCodeChange = (event) =>{
        this.setState({code: event.target.value.toUpperCase()});
    } 

    handleActivityChange = (event,index) =>{
        const newActivities = [...this.state.activities];
        newActivities[index] = event.target.value;
        this.setState({activities:newActivities});
        console.log(this.state.activities)
    }

    handleDeleteActivity = (event) =>{
        const index = Number(event.target.dataset.index)
        const filteredActivities = this.state.activities.filter((activity,i)=> i !== index);//return the array with data of index other than current index
        this.setState({activities:filteredActivities});
        console.log(this.event);
    }

    handleAddActivityClick = () =>{
        this.setState({activities:[...this.state.activities,'']})
    }

    handleSave = () =>{
        const addedScheme = {
            code: this.state.code,
            name: this.state.name,
            activities: this.state.activities,
        }
        
        this.props.onAddScheme(addedScheme);//send updated scheme data back to parents

        this.setState({
            code:'',
            name:'',
            activities:['']
        })
    }

    render(){
        return(
            <div>
                <b>Scheme Name :</b><br />
                <input type="text" className="form-control" placeholder="Scheme name" value={this.state.name} onChange={this.handleNameChange}/><br />
                <b>Scheme Code :</b><br />
                <input type="text" className="form-control" placeholder="Scheme code" value={this.state.code} onChange={this.handleCodeChange}/><br />
                <b>Scheme Activities :</b><br />
                {this.state.activities.map((activity,index)=>(
                    <div key={index} className="d-flex align-items-center" >
                        <input type="textarea" className="form-control" value={activity} onChange={event => this.handleActivityChange(event,index)} placeholder="Scheme activity"/>
                        <button className="m-1 btn btn-outline-red" disabled={this.state.activities.length === 1} data-index={index} onClick={this.handleDeleteActivity}><i className="fas fa-trash"></i></button>
                    </div>
                ))}
                
                <button className="btn m-2 btn-outline-black" onClick={this.handleAddActivityClick}><i className="fas fa-plus" />{' '}Add Scheme Activities</button>
                <br />

                <div className="mt-5 row justify-content-end">
                    <button type="button" className="btn m-2 btn-outline-black" onClick={this.handleSave}>
                        <i className="fas fa-plus-circle"/>{' '} Add New Scheme
                    </button>
                </div>
            </div>
        )
    }
}

export default SchemeInfo